export function highlightTarget(node, { nodeId, targetId, callback }) {
    if (nodeId && targetId && nodeId === targetId) {

        // Ensure element is scrolled into view after next paint
        requestAnimationFrame(() => {
            node.scrollIntoView({
                block: "center",
                behavior: "smooth"
            });

            // Double check if element is fully visible after scroll
            const observer = new IntersectionObserver((entries) => {
                const [entry] = entries;
                if (!entry.isIntersecting) {
                    // If not fully visible, try scrolling again
                    node.scrollIntoView({
                        block: "center",
                        behavior: "smooth",
                    });
                }
                observer.disconnect();
            });

            observer.observe(node);

            /**
             * Instead of modifying the style of all subcomponents the filter is used for coloring the whole node.
             * To avoid "rainbow" effect the filter is removed in 2 steps:
             * 1. sepia(1) is removed - Grayscale takes over so the node is grey
             * 2. filter is removed - Node is back to normal so the button colors are colored again
             */
            node.setAttribute(
                "style",
                "filter: grayscale(1) contrast(0.5) sepia(1) hue-rotate(215deg) !important;",
            );

            setTimeout(() => {
                // turn off sepia
                node.setAttribute(
                    "style",
                    "filter: grayscale(1) contrast(1) sepia(0) hue-rotate(215deg) !important; transition: all 0.3s ease-in-out;",
                );

                // turn off filter
                setTimeout(() => {
                    node.setAttribute("style", "transition: all 0.3s ease-in-out;");

                    if (typeof callback === "function") callback();
                }, 300);
            }, 1500);
        });
    }
}